import {
  CREATE_RESULT,
  CREATE_RESULT_SUCCESS,
  CREATE_RESULT_FAILURE,
  UPDATE_RESULT,
  UPDATE_RESULT_SUCCESS,
  UPDATE_RESULT_FAILURE,
  MARK_RESULT,
  MARK_RESULT_SUCCESS,
  MARK_RESULT_FAILURE,
  GET_RESULT_BY_TEST_ID,
  GET_RESULT_BY_TEST_ID_SUCCESS,
  GET_RESULT_BY_TEST_ID_FAILURE,
  GET_RESULTS_COUNT,
  GET_RESULTS_COUNT_SUCCESS,
  GET_RESULTS_COUNT_FAILURE,
  FETCH_RESULTS_BY_CANDIDATE_ID,
  FETCH_RESULTS_BY_CANDIDATE_ID_SUCCESS,
  FETCH_RESULTS_BY_CANDIDATE_ID_FAILURE,
} from "./actionTypes";

const initialState = {
  results: [],
  result: {},
  resultsCount: null,
};

const ResultsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Create Result
    case CREATE_RESULT:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case CREATE_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    case CREATE_RESULT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Update Result
    case UPDATE_RESULT:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case UPDATE_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    case UPDATE_RESULT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Mark Result
    case MARK_RESULT:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case MARK_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    case MARK_RESULT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Get Result by id
    case GET_RESULT_BY_TEST_ID:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_RESULT_BY_TEST_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.payload,
      };
    case GET_RESULT_BY_TEST_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_RESULTS_BY_CANDIDATE_ID:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case FETCH_RESULTS_BY_CANDIDATE_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.payload,
      };
    case FETCH_RESULTS_BY_CANDIDATE_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Get Result by id
    case GET_RESULT_BY_TEST_ID:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_RESULT_BY_TEST_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.payload,
      };
    case GET_RESULT_BY_TEST_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Get Result count
    case GET_RESULTS_COUNT:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_RESULTS_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        resultsCount: action.payload,
      };
    case GET_RESULTS_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default ResultsReducer;
